import {gsap, Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	static init() {
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.headerClass = this.header.className.replace("is-on-top", "");
			this.toggleHeader();
			this.resize();

		}
		GlobalVariables.resizeCallbacks.push(this);
	}

	static toggleHeader() {
		Observer.create({
			type: "scroll",
			tolerance: 30,
			dragMinimum: 30,
			onStop: () => {
				if (window.scrollY < 100) {
					this.header.classList.add("is-on-top");
					this.header.classList.remove("show");
				} else {
					this.header.classList.remove("is-on-top");
				}
			},
			onStopDelay: 0,
			onUp: () => {
				this.showHeader();
			},
			onDown: () => {
				this.hideHeader();
			},
		});

		if (window.innerWidth > 991) {
			setTimeout(() => {
				if (window.scrollY > 100) {
					this.hideHeader();
				}
			}, 0);
		}
	}

	static hideHeader() {
		this.header.classList.add("hide");
		this.header.classList.remove("show");
	}

	static showHeader() {
		this.header.classList.remove("hide");
		this.header.classList.add("show");
		this.header.classList.remove("is-on-top");
	}

	static resize() {
		if (window.innerWidth > 991) {
			document.body.classList.remove("navs-open");
			GlobalVariables.lenis?.start();
		}
	}
}
